import {LanguageDomainModel} from "./language.domain-model";
import {computed} from "mobx";
import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {LanguageLinkModel} from "../../../../infrastructure/models/link/language-link-model";
import {LanguageLogoParams} from "./language-logo-params";
import {Type} from "../../../../infrastructure/type";
import type {NavigationManager} from "../../../../core/managers/navigation-manager";

export class LanguageViewModel extends EntityViewModel {
  domainModel: LanguageDomainModel;
  navigationManager: NavigationManager;

  constructor(domainModel, navigationManager) {
    super(domainModel);

    this.navigationManager = navigationManager;
  }

  @computed get direction() {
    return this.domainModel?.direction;
  }

  @computed get cultureName() {
    return this.domainModel?.cultureName;
  }

  @computed get displayName() {
    return this.domainModel?.displayName;
  }

  @computed get didomiCode() {
    return this.domainModel?.didomiCode;
  }

  get hreflang(): Boolean {
    return this.domainModel?.hreflang;
  }

  get invalidUserCountryIds(): Array<Number> {
    return this.apiModel.invalidUserCountryIds;
  }

  get logoType(): Type {
    return LanguageLogoParams;
  }

  @computed get linkModel(): LanguageLinkModel {
    return this.navigationManager ? new LanguageLinkModel(this.displayName, this.navigationManager) : null;
  }

  @computed get symbolName(): String {
    return this.cultureName.split('-')[0].toUpperCase();
  }
}
